import React from "react";
import { ScrollReveal } from "./scroll-reveal";

export const TeamSection = ({ t }) => {
  if (!t.team) return null;

  return (
    <section id="team" className="py-20 relative">
      <div className="container relative z-10">
        <ScrollReveal className="flex items-center mb-12">
          <h2 className="text-3xl font-mono font-bold text-white">
            <span className="text-amber mr-2">$</span>
            whoami --all
          </h2>
          <div className="flex-grow h-px bg-white/10 ml-6"></div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {t.team.members.map((member, idx) => (
            <ScrollReveal key={idx} delay={idx * 0.1} className="group relative bg-black/20 backdrop-blur-sm border border-white/5 hover:border-amber/50 transition-all duration-300 overflow-hidden">
              <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-transparent via-amber/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              
              <div className="p-6 flex flex-col items-center text-center">
                <div className="w-32 h-32 mb-4 relative rounded-full overflow-hidden border-2 border-white/10 group-hover:border-amber/50 transition-colors">
                  <img 
                    src={member.img} 
                    alt={member.name}
                    className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 transition-all duration-500"
                    onError={(e) => {
                      e.target.onerror = null;
                      // Generative fallback based on name
                      e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(member.name)}&background=0D0D0D&color=F59E0B&size=200`; 
                    }}
                  />
                  {/* Scanline overlay */}
                  <div className="absolute inset-0 bg-[linear-gradient(rgba(18,16,16,0)_50%,rgba(0,0,0,0.25)_50%),linear-gradient(90deg,rgba(255,0,0,0.06),rgba(0,255,0,0.02),rgba(0,0,255,0.06))] z-10 pointer-events-none bg-[length:100%_2px,3px_100%]"></div>
                </div>

                <h3 className="text-xl font-bold text-white mb-1">{member.name}</h3>
                <div className="text-emerald-400 font-mono text-xs mb-4 uppercase tracking-wider">
                  [{member.role}]
                </div>

                <a 
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-blue-500/50 rounded text-xs font-mono text-white/70 hover:text-white transition-all group-hover:shadow-[0_0_15px_rgba(59,130,246,0.3)]"
                >
                  <svg className="w-4 h-4 text-blue-400" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                  LINKEDIN_PROFILE
                </a>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};
